// import React from "react";
// import { Navbar, Container, Button, Popover, OverlayTrigger } from "react-bootstrap";
// import logo from '../../components/logo/srma-logo.webp';
// import '../../../src/pages/Website/webStyle.css'

// const WebsiteNavbar = () => {
//     const popover = (
//         <Popover id="popover-basic mt-2">
//             <Popover.Body>
//                 <div className="text-center">
//                     <Button variant="primary" className="mb-2 w-100">Log In</Button>
//                     <Button variant="secondary" className="w-100">Register Now</Button>
//                 </div>
//             </Popover.Body>
//         </Popover>
//     );

//     return (
//         <Navbar expand="lg">
//             <Container>
//                 <Navbar.Brand href="#"><img src={logo} width="15%" alt="Logo" /></Navbar.Brand>
//                 <OverlayTrigger trigger="hover" placement="bottom" overlay={popover}>
//                     <Button className="webButton">LOGIN</Button>
//                 </OverlayTrigger>
//             </Container>
//         </Navbar>
//     );
// };

// export default WebsiteNavbar;


import React, { useEffect, useState } from "react";
import { Navbar, Button, Container, Overlay, Nav, NavDropdown, Row, Col } from "react-bootstrap";
import { useRef } from "react";
import logo from '../../components/logo/srma-logo.webp';
import '../../../src/pages/Website/webStyle.css';
import sellerLogo from '../../components/icons/seller.png';
import buyerLogo from '../../components/icons/buyer.png';
import Iconify from "src/components/iconify";
import rightArrow from '../../components/icons/right-arrow.png';
import { Link, useNavigate } from "react-router-dom";
import { Autocomplete, Avatar, Box, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, IconButton, InputAdornment, MenuItem, Popover, setRef, TextField, Typography } from "@mui/material";
import { alpha } from '@mui/material/styles';
import { toast, ToastContainer } from "react-toastify";
import { countries } from "country-data";
import uploadIcon from '../../components/images/profile-picture.png';
import { getData, patchFormData } from "src/webService/webService";
import hanger from '../../components/images/hanger.png';
import ViewSeller from "./viewSeller";



const WebsiteNavbar = (props) => {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const buyerName = sessionStorage.getItem('BuyerName');
    const role = sessionStorage.getItem('Role');
    const [open, setOpen] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('');
    const [whatsappCountryCode, setWhatsappCountryCode] = useState('');
    const [gstNo, setGstNo] = useState('');
    const [whatsappNo, setWhatsappNo] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [profileImage, setProfileImage] = useState(null);
    const [preview, setPreview] = useState('');
    const [isRegNo, setIsRegNo] = useState(false);
    const [edit, setEdit] = useState('Edit');
    const [sellerViewList, setSellerViewList] = useState('');
    const initialImage = uploadIcon;
    const Token = sessionStorage.getItem('Token');
    const [searchQuery, setSearchQuery] = useState('');
    let debounceTimer = useRef(null);

    const handleEdit = (e, status) => {
        setEdit(status);
    }

    const handleOpenModal = () => {
        setEdit("Edit")
        setOpenModal(true);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
        handleClose()
    }

    const navigate = useNavigate();

    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClose = () => {
        setOpen(null);
    };

    const handleSubmit = () => {
        sessionStorage.clear();
        navigate("/home");
        toast.success('Logout Successfully')
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setProfileImage(file)
        }
    };

    const dialCodes = countries.all.map(c => ({
        dialCode: c.countryCallingCodes[0],
    }));

    const validDialCodes = dialCodes
        .filter(item => item.dialCode && item.dialCode.trim() !== '')
        .map(item => item.dialCode);

    const getBuyer = async (id) => {
        debugger
        try {
            const res = await getData(`buyer/profile`, null, Token);
            setName(res?.buyer?.name);
            setEmail(res?.buyer?.email);
            setWhatsappNo(res?.buyer?.whatsapp);
            setPhoneNo(res?.buyer?.phone);
            setPreview(res?.buyer?.photo === null ? initialImage : res?.buyer?.photo);
            setCity(res?.buyer?.city);
            setState(res?.buyer?.state);
            setCountry(res?.buyer?.country);
            setWhatsappCountryCode(res?.buyer?.whatsapp_countrycode);
            // setWhatsappNo(res?.buyer?.whatsapp);
            setGstNo(res?.buyer?.gst_number)
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    useEffect(() => {
        getBuyer();
    }, [openModal])


    const getSearch = async (id) => {
        try {
            const res = await getData(`buyer/search?search=${searchQuery}`, null, Token);
            setSellerViewList(res?.data)

        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    useEffect(() => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        if (searchQuery.length >= 3) {
            debounceTimer.current = setTimeout(() => {
                getSearch();
            }, 500);
        }
        return () => clearTimeout(debounceTimer.current);
    }, [searchQuery]);

    const handleUpdateProfile = async () => {

        const fields = {
            Name: name,
            City: city,
            Country: country,
            State: state,
            'WhatsApp Number': whatsappNo,
            'WhatsApp Country Code': whatsappCountryCode,
        };

        for (const [label, value] of Object.entries(fields)) {
            if (!value || value.toString().trim() === '') {
                toast.error(`${label} field is empty`, {
                    position: 'top-right',
                    autoClose: 3000,
                });
                return;
            }
        }

        const payLoad = {
            name: name,
            photo: profileImage,
            city: city,
            country: country,
            state: state,
            whatsapp: whatsappNo,
            whatsapp_countrycode: whatsappCountryCode,
            gst_number: gstNo,
            in_india: whatsappCountryCode === "+91" ? false : true
        }

        const formData = new FormData();
        for (const key in payLoad) {
            formData.append(key, payLoad[key]);
        }

        const res = await patchFormData('buyer/update', formData, Token)
            .then((res) => {
                handleCloseModal();
                handleClose();
                toast.success(res.message);
            }).catch((error) => {
                console.error("Error:", error);
            });
    }

    const [showSearch, setShowSearch] = useState(false);

    const handleOpenSearch = (e) => {
        e.preventDefault(); // prevent route navigation
        setShowSearch(true);
    };

    const handleCloseSearch = (e) => {
        e.preventDefault(); // prevent route navigation
        setShowSearch(false);
    };

    const [showSellerById, setShowSellerById] = useState(false);
    const [sellerId, setSellerId] = useState('');

    const handleViewSeller = (id) => {
        navigate(`/search/seller/${id}`);
        setShowSellerById(!showSellerById);
        setSellerId(id);
        setShowSearch(false);
        setSearchQuery('');
    }


    return (
        <>
            <ToastContainer position="top-right" />
            <Navbar className="position-absolute" expand="lg" fixed="top" style={{ height: '100px', zIndex: 1 }}>
                <Container>
                    <div className="LoginButton">
                    <Link to="/home"><img src={logo} width="15%" alt="Logo" /></Link>
                    {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                    {role === 'Buyer' ? (
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Link to='/categories' onClick={handleOpenSearch} className="nav-link d-flex align-items-center">
                                    <Iconify style={{ marginRight: '6px' }} icon="eva:search-outline" /> Search
                                </Link>
                            </Nav>
                        </Navbar.Collapse>
                    ) : (
                        <></>
                    )
                    }

                    {(props.loginButton != 'hide') ? (role === 'Buyer' ? (
                        <div onClick={handleOpen}>
                            <IconButton
                                sx={{
                                    p: 0,
                                    ...(open && {
                                        '&:before': {
                                            zIndex: 1,
                                            content: "''",
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '50%',
                                            position: 'absolute',
                                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
                                        },
                                    }),
                                }}
                            >
                                <Avatar alt="photoURL" src={preview} />
                            </IconButton>                          
                            <Popover
                                open={Boolean(open)}
                                anchorEl={open}
                                onClose={handleClose}
                                disableRestoreFocus
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                PaperProps={{
                                    sx: {
                                        p: 0,
                                        mt: 1.5,
                                        ml: 0.75,
                                        width: 180,
                                        '& .MuiMenuItem-root': {
                                            typography: 'body2',
                                            borderRadius: 0.75,
                                        },
                                    },
                                }}
                            >
                                <MenuItem onClick={handleOpenModal} sx={{ m: 1 }}>
                                    <Typography variant="subtitle3" noWrap>{buyerName}</Typography>
                                </MenuItem>
                                <Divider sx={{ borderStyle: 'dashed' }} />

                                <MenuItem onClick={handleSubmit} sx={{ m: 1 }}>
                                    Logout
                                </MenuItem>
                            </Popover>
                        </div>
                    ) : (
                        <Button 
                            className="webButton Loginbutton"
                            ref={target}
                            onMouseEnter={() => setShow(true)}
                            onMouseLeave={() => setShow(false)}
                        >
                            LOGIN
                        </Button>
                    )) : <></>}
                </div>

                    {/* {!showSellerById ? ( */}
                    <Dialog open={showSearch} onClose={handleCloseSearch} maxWidth='lg' fullWidth >
                        <DialogTitle className="d-flex justify-content-between align-items-center">Search</DialogTitle>
                        <DialogContent>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Iconify icon="eva:search-outline" />
                                        </InputAdornment>
                                    ),
                                }}
                                style={{ marginBottom: '1rem' }}
                            />
                            <div className="container mt-3">
                                <div className="row seller-listing">
                                    {sellerViewList?.length === 0 ? (
                                        <div>
                                            <h5 className="text-center">No Data found</h5>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <img src={hanger} width='10%' />
                                            </div>
                                            <p className="text-center pointer">Back</p>
                                        </div>
                                    ) : (
                                        sellerViewList.map((item, index) => (
                                            <div className="col-lg-6" key={index}>
                                                <div className='sellerCardLayout'
                                                    onClick={() => handleViewSeller(item?._id)}
                                                >
                                                    <div className="w-35">
                                                        <img className="sellerCardLayoutImg" src={item?.profile_picture} />
                                                    </div>
                                                    <div className="d-flex w-65">
                                                        <div>
                                                            <div className="d-flex">
                                                                <h4 style={{ fontWeight: '600' }} className='pt-2 pb-1 pointer'>{item?.name}</h4>
                                                            </div>

                                                            <p style={{ fontWeight: '600', fontSize: '14px' }} className='pt-0 mb-0'><Iconify icon="eva:pin-outline" style={{ width: '16px' }} /> {item?.location ? item?.location : 'No Location Found :('}</p>
                                                            <div>
                                                                <p className="seller-about" style={{ fontSize: '14px', marginTop: '12px' }}><Iconify icon="eva:alert-circle-outline" style={{ width: '16px' }} /> {item?.aboutus}</p>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseSearch}>Close</Button>
                        </DialogActions>
                    </Dialog>
                    {/* ) : (
                        <ViewSeller id={sellerId} />
                    )} */}


                    <Dialog open={openModal} onClose={handleCloseModal} maxWidth='md' fullWidth>
                        <DialogTitle className="d-flex justify-content-between align-items-center">Buyer Profile
                            {edit === 'Edit' ? (
                                <Button className="webButton" onClick={(e) => handleEdit(e, 'Cancel')}><Iconify icon="eva:edit-outline" /> Edit</Button>
                            ) : (
                                <Button className="webButton" onClick={(e) => handleEdit(e, 'Edit')}><Iconify icon="eva:close-outline" /> Cancel</Button>
                            )}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <div style={{ textAlign: "center" }}>
                                        <input
                                            type={edit === 'Cancel' ? "file" : 'text'}
                                            accept="image/*"
                                            id="fileInput"
                                            style={{ display: "none" }}
                                            onChange={handleImageChange}
                                        />
                                        <label htmlFor="fileInput">
                                            <img
                                                src={preview}
                                                alt="Uploaded"
                                                style={{
                                                    width: '115px',
                                                    height: '90px',
                                                    objectFit: 'contain',
                                                    cursor: 'pointer',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3'
                                                }}
                                            />
                                            <p className='mb-0' style={{ fontSize: '12px' }}>Update Profile image</p>
                                        </label>
                                    </div>
                                </Grid>
                                <Grid item xs={6} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        label="Name *"
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        label="Email Id *"
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        label="City *"
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                        label="State *"
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                        label="Country *"
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} className='mt-3'>
                                    <Autocomplete
                                        options={validDialCodes}
                                        value={whatsappCountryCode}
                                        onChange={(event, newValue) => {
                                            if (edit !== 'Edit') {
                                                setWhatsappCountryCode(newValue);
                                            }
                                        }}
                                        open={edit === 'Edit' ? undefined : false}
                                        onOpen={(event) => {
                                            if (edit === 'Edit') {
                                                event.preventDefault();
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Country Code *"
                                                variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    readOnly: edit === 'Edit',
                                                    disableUnderline: edit === 'Edit',
                                                    // Hides the dropdown arrow
                                                    endAdornment: edit === 'Edit' ? null : params.InputProps.endAdornment,
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={4} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        // InputProps={{
                                        //     readOnly: action === "View",
                                        // }}
                                        value={whatsappNo}
                                        onChange={(e) => setWhatsappNo(e.target.value)}
                                        label="whatsapp No *"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} className='mt-3'>
                                    <Autocomplete
                                        options={validDialCodes}
                                        value={whatsappCountryCode}
                                        onChange={(event, newValue) => {
                                            if (edit !== 'Edit') {
                                                setWhatsappCountryCode(newValue);
                                            }
                                        }}
                                        open={edit === 'Edit' ? undefined : false}
                                        onOpen={(event) => {
                                            if (edit === 'Edit') {
                                                event.preventDefault();
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Country Code *"
                                                variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    readOnly: edit === 'Edit',
                                                    disableUnderline: edit === 'Edit',
                                                    // Hides the dropdown arrow
                                                    endAdornment: edit === 'Edit' ? null : params.InputProps.endAdornment,
                                                }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={4} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        // InputProps={{
                                        //     readOnly: action === "View",
                                        // }}
                                        value={phoneNo}
                                        onChange={(e) => setPhoneNo(e.target.value)}
                                        label="Phone No*"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={6} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        value={gstNo}
                                        onChange={(e) => setGstNo(e.target.value)}
                                        label={isRegNo ? 'Reg No *' : 'GST No *'}
                                        variant={edit === 'Cancel' ? 'outlined' : 'standard'}
                                        InputProps={{
                                            readOnly: edit === 'Edit',
                                            disableUnderline: edit === 'Edit',
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                {edit === 'Cancel' && (
                                    <Grid item xs={12} className='mt-3'>
                                        <Button
                                            className="webButton w-100"
                                            onClick={handleUpdateProfile}
                                        >
                                            UPDATE PROFILE
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        </DialogContent>
                    </Dialog>

                    {/* Popover Component */}
                    <Overlay target={target.current} show={show} placement="bottom">
                        {({ placement, arrowProps, show: _show, popper, ...props }) => (
                            <div
                                {...props}
                                style={{
                                    width: '50%',
                                    backgroundColor: "white",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    zIndex: 1000,
                                    ...props.style
                                }}
                                onMouseEnter={() => setShow(true)}
                                onMouseLeave={() => setShow(false)}
                            >
                                <Row>
                                    <Col>
                                        <Link className="header-nav-link" to="/seller/login">
                                            <div className="d-flex justify-content-center mb-2">
                                                <img src={sellerLogo} width='10%' />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <h6 className="mb-0" style={{ fontSize: '20px', marginRight: '12px' }}>Sellers</h6>
                                                <img src={rightArrow} width='20' className="nav-arrow" />
                                            </div>
                                            <p className="fs-12">SRMA members, step in to showcase and grow your business</p>
                                        </Link>
                                    </Col>
                                    <Col>
                                        <Link className="header-nav-link" to="/buyer/login">
                                            <div className="d-flex justify-content-center mb-2">
                                                <img src={buyerLogo} width='10%' />
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <h6 className="mb-0" style={{ fontSize: '20px', marginRight: '12px' }}>Buyers</h6>
                                                <img src={rightArrow} width='20' className="nav-arrow" />
                                            </div>
                                            <p className="fs-12">Find the right sellers, connect directly, and grow your business smarter</p>
                                        </Link>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Overlay>
                </Container>
            </Navbar>
        </>
    );
};

export default WebsiteNavbar;
